import React from "react";
import { i18n } from '../../../lang/i18n';
import DC from "../../../common/DataConnector";
import BackArrow from "../../../components/BackArrowComponent/BackArrow";
import UserInvoice from "./UserInvoice";
import { renderIcon } from "../../../common/Medias";
import ScrollToTop from "../../../components/ScrollToTop";

export default function UserInvoices()
{
    const [invoices, setInvoices] = React.useState<any[]>([])
    const [invoice, setInvoice] = React.useState<any>(undefined)

    React.useEffect(() =>
    {
        (async function ()
        {
            let content = await DC.Get('/customer/invoices', {});
            if (content.wasOk) {
                setInvoices(content.data);
            }
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (<div className="users">
        <ScrollToTop />
        <div className="main-subtitle">
            <h3>{i18n.Customer.InvoicesTitle}</h3>
        </div>
        {!invoice && <div className="invoices">
            {invoices.map((item: any, index: number) => (
                <div key={index} className="invoice-row" onClick={() => setInvoice(item)}>
                    <div className="invoice-row-body">
                        <div className="invoice-row-number">{item.invoiceNumber}</div>
                        <div className="invoice-row-date"><span className="mr-2">{renderIcon('menu-calendar')}</span>{item.invoiceDate}</div>
                    </div>
                    <div>
                        <div className="invoice-row-price">{item.totalPrice.toFixed(2)} €</div>
                        {item.ritmitosLoyalty > 0 && <div className="invoice-row-price">{item.ritmitosLoyalty}⚡</div>}
                    </div>
                </div>
            ))}
            <BackArrow path="/user" />
        </div>}
        {invoice && <UserInvoice invoice={invoice} onClose={() => setInvoice(undefined)} />}
    </div>
    );
}